import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTicketAlt, faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';
import { getTicketStatusBadge } from './tagStatusHelper';
import { formatDateTime } from '../../../utils';

/**
 * Sección de visualización de tickets vinculados a una incidencia
 */
const TagLinkedTicketsSection = ({
  tagTickets = [],
  isLoadingTagTickets = false,
  isDark = false
}) => {
  return (
    <div className="pt-2 border-top mb-3" style={{ borderColor: isDark ? '#233142' : '#e2e8f0' }}>
      <div className="d-flex align-items-center justify-content-between mb-2">
        <div className="d-flex align-items-center gap-2">
          <FontAwesomeIcon icon={faTicketAlt} style={{ color: '#6366f1' }} />
          <span className="fw-bold small" style={{ color: isDark ? '#f9fafd' : '#0f172a' }}>
            Tickets Vinculados ({tagTickets.length})
          </span>
        </div>
        {tagTickets.length > 0 && (
          <span className="text-muted" style={{ fontSize: '0.74rem' }}>
            {tagTickets.filter(t => t.iEstadoTicket !== 2).length} activo(s) · {tagTickets.filter(t => t.iEstadoTicket === 2).length} resuelto(s)
          </span>
        )}
      </div>

      {isLoadingTagTickets ? (
        <div className="text-center py-3 text-muted">
          <span className="spinner-border spinner-border-sm me-2" role="status" />
          <span className="small">Cargando tickets vinculados...</span>
        </div>
      ) : tagTickets.length === 0 ? (
        <div
          className="p-3 rounded-3 border text-center"
          style={{
            backgroundColor: isDark ? '#101c26' : '#f8fafc',
            borderColor: isDark ? '#233142' : '#e2e8f0'
          }}
        >
          <FontAwesomeIcon icon={faTicketAlt} className="text-muted opacity-50 mb-1" style={{ fontSize: '1.4rem' }} />
          <p className="small text-muted mb-0" style={{ fontSize: '0.8rem' }}>
            No hay tickets vinculados a esta incidencia actualmente.
          </p>
        </div>
      ) : (
        <div className="d-flex flex-column gap-2" style={{ maxHeight: '240px', overflowY: 'auto' }}>
          {tagTickets.map(ticket => {
            const ticketStatus = getTicketStatusBadge(ticket.iEstadoTicket, isDark);
            const customerName = (ticket.vCustomerName || '').trim();
            const phone = ticket.vTelefono;
            const ticketUrl = `/support-engine/ticket/${ticket.idTicket}`;

            return (
              <div
                key={ticket.idTicket}
                className="p-2.5 rounded-3 border d-flex flex-column gap-1"
                style={{
                  backgroundColor: isDark ? '#101c26' : '#ffffff',
                  borderColor: isDark ? '#233142' : '#e2e8f0'
                }}
              >
                <div className="d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center gap-2 flex-wrap">
                    <a
                      href={ticketUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="badge fw-bold px-2 py-1 rounded-pill text-decoration-none d-inline-flex align-items-center gap-1"
                      title={`Abrir ticket #${ticket.idTicket} en nueva pestaña`}
                      style={{
                        backgroundColor: isDark ? '#1e293b' : '#e0e7ff',
                        color: '#6366f1',
                        fontSize: '0.74rem',
                        cursor: 'pointer',
                        transition: 'all 0.15s ease-in-out'
                      }}
                      onMouseEnter={e => {
                        e.currentTarget.style.backgroundColor = '#6366f1';
                        e.currentTarget.style.color = '#ffffff';
                      }}
                      onMouseLeave={e => {
                        e.currentTarget.style.backgroundColor = isDark ? '#1e293b' : '#e0e7ff';
                        e.currentTarget.style.color = '#6366f1';
                      }}
                    >
                      <span>#{ticket.idTicket}</span>
                      <FontAwesomeIcon icon={faExternalLinkAlt} style={{ fontSize: '0.62rem' }} />
                    </a>

                    <span className="fw-semibold" style={{ fontSize: '0.82rem', color: isDark ? '#f9fafd' : '#0f172a' }}>
                      {customerName || phone || 'Cliente sin registrar'}
                    </span>

                    {customerName && phone && (
                      <span className="text-muted" style={{ fontSize: '0.74rem' }}>
                        ({phone})
                      </span>
                    )}
                  </div>

                  <div className="d-flex align-items-center gap-2">
                    {ticket.dUltimaActividad && (
                      <span className="text-muted" style={{ fontSize: '0.7rem' }}>
                        {formatDateTime(ticket.dUltimaActividad)}
                      </span>
                    )}
                    <span
                      className="badge px-2 py-0.5 rounded-pill fw-semibold"
                      style={{
                        backgroundColor: ticketStatus.bg,
                        color: ticketStatus.color,
                        border: `1px solid ${ticketStatus.border}`,
                        fontSize: '0.68rem'
                      }}
                    >
                      {ticketStatus.label}
                    </span>
                  </div>
                </div>

                {(ticket.vAsunto || ticket.vUltimoMensaje) && (
                  <div
                    className="text-muted text-truncate"
                    style={{ fontSize: '0.74rem' }}
                    title={ticket.vAsunto || ticket.vUltimoMensaje}
                  >
                    {ticket.vAsunto ? (
                      <span><strong>Asunto:</strong> {ticket.vAsunto}</span>
                    ) : (
                      <span>{ticket.vUltimoMensaje}</span>
                    )}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default TagLinkedTicketsSection;
